import { toast } from '@/view/shared/Toast';
import { registerNotifier } from '@/viewmodel/shared/notify';

export function registerToastNotifier(): void {
  registerNotifier((message, severity, { duration, action }) => {
    toast[severity](message, {
      timeout: duration,
      ...(action && { actionProps: { children: action.label, onPress: action.onPress } }),
    });
  });
}
